@use "~theme/typography";
@use "~theme/breakpoints";

.slotWrapper{
    width: 100%;
    box-shadow: 0px 2px 6px var(--gray-03);
    border-radius: 4px;
    background: white;
    margin: 10px 0px;
    display: block;
    overflow: auto;
    padding: 14px 10px;
}
